import * as Mui from "@mui/material";
import React, { useContext, useEffect } from "react";
import { ContextOperation } from "../../context/OperationContext";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import { ContextDamageForm } from "./DamageFormContext";
import DamageFormNavigator from "./DamageFormNavigator";
import useDamageFormActions from "./service/DamageFormActions";
import DamageFormService from "./service/DamageFormService";
import SectionHeader from "../../../../util/component/SectionHeader";
import { useSearchParams } from "react-router-dom";

const DamageFormDetails = () => {
    //const { tenant } = useContext(ContextOperation);
    const [searchParams] = useSearchParams();
    const operationContext = useContext(ContextOperation);
    const tenant = searchParams.get("tenant") ?? operationContext.tenant;

    const damageFormContext = useContext(ContextDamageForm);

    const t = useOperationTranslation();

    const actions = useDamageFormActions();

    useEffect(() => {
        if (!damageFormContext.eventTypes) {
            DamageFormService.details.domains.getEventTypes(tenant, false).then(
                (response) => {
                    damageFormContext.setEventTypes(response);
                }
            );
        }
        ;

        if (!damageFormContext.attachmentTypes) {
            DamageFormService.details.domains.getAttachmentTypes(tenant).then(
                response => {
                    damageFormContext.setAttachmentTypes(response);
                }
            )
        }

        if (!damageFormContext.documentTypes) {
            DamageFormService.details.domains.getDocumentTypes(tenant).then(
                (response) => {
                    damageFormContext.setDocumentTypes(response);
                }
            )
        }

        if (!damageFormContext.msList) {
            DamageFormService.details.domains.getMsListTypes(tenant).then(
                (response) => {
                    damageFormContext.setMsList(response);
                }
            )
        }

        if (!damageFormContext.rsList) {
            DamageFormService.details.domains.getRsListTypes(tenant).then(
                (response) => {
                    damageFormContext.setRsList(response);
                }
            )
        }

        if (!damageFormContext.generalInfo) {
            actions.getGeneralInfo();
        }

        return () => {
            damageFormContext.setGeneralInfo(undefined);
            damageFormContext.setTask1(undefined);
            damageFormContext.setTask2(undefined);
            damageFormContext.setTask3(undefined);
        }
    }, [tenant]);

    return (
        <>
            <SectionHeader
                title={t("damageForm.details.titleHeader.firstTitle") + " " + t("damageForm.details.titleHeader.secondTitle")}
                subtitle={<Mui.Grid container>
                    <Mui.Grid item>
                        <Mui.Typography variant="h5">
                            {t("damageForm.details.titleHeader.labels.id")}
                        </Mui.Typography>
                    </Mui.Grid>
                    <Mui.Grid item sx={{ ml: "5px" }}>
                        <Mui.Typography>
                            {damageFormContext.generalInfo?.progressive}
                        </Mui.Typography>
                    </Mui.Grid>

                    <Mui.Grid item sx={{ ml: "30px" }}>
                        <Mui.Typography variant="h5">
                            {t("damageForm.details.titleHeader.labels.plate")}
                        </Mui.Typography>
                    </Mui.Grid>
                    <Mui.Grid item sx={{ ml: "5px" }}>
                        <Mui.Typography>
                            {damageFormContext.generalInfo?.plate}
                        </Mui.Typography>
                    </Mui.Grid>

                    <Mui.Grid item sx={{ ml: "30px" }}>
                        <Mui.Typography variant="h5">
                            {t("damageForm.details.titleHeader.labels.model")}
                        </Mui.Typography>
                    </Mui.Grid>
                    <Mui.Grid item sx={{ ml: "5px" }}>
                        <Mui.Typography>
                            {damageFormContext.task1?.vehicle}
                        </Mui.Typography>
                    </Mui.Grid>

                    <Mui.Grid item sx={{ ml: "30px" }}>
                        <Mui.Typography variant="h5">
                            {t("damageForm.details.titleHeader.labels.status")}
                        </Mui.Typography>
                    </Mui.Grid>
                    <Mui.Grid item sx={{ ml: "5px" }}>
                        <Mui.Typography>
                            {damageFormContext.generalInfo?.open === true ? "Open" : "Closed"}
                        </Mui.Typography>
                    </Mui.Grid>

                    <Mui.Grid item sx={{ ml: "30px" }}>
                        <Mui.Typography variant="h5">
                            {t("damageForm.details.titleHeader.labels.raId")}
                        </Mui.Typography>
                    </Mui.Grid>
                    <Mui.Grid item sx={{ ml: "5px" }}>
                        <Mui.Typography>
                            {damageFormContext.task1?.raId ? damageFormContext.task1?.raId : "-"}
                        </Mui.Typography>
                    </Mui.Grid>

                </Mui.Grid>}
            />

            <DamageFormNavigator />
        </>
    );
};
export default DamageFormDetails;